import type {
  ICategoryCompetitions,
  ICup,
  ICupCompetitionInfo,
  ICupHighlight,
  ICupsGallery,
  ICupsInfo,
  ICupsWinner,
} from "@/types";

export const cupsInfo: ICupsInfo = {
  id: 1,
  title: "Taça de Portugal",
  cup_text:
    "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore <br/> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore</p>",
  logo: {
    path: "/cups/slide1/cups-logo.svg",
    mime_type: "image/png",
    caption: "logo",
  },
  trophy_image: {
    path: "/cups/slide1/trophy.png",
    mime_type: "image/png",
    caption: "logo",
  },
  competition_image: {
    path: "/cups/slide1/Foto2.png",
    mime_type: "image/png",
    caption: "competition full image",
  },
  description:
    "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore <br/> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore</p>",
};

export const cupWinners: ICupsWinner = {
  winnings: Array.from({ length: 12 }, (_, id) => ({
    id,
    team_name: "Team Name Placeholder",
    team_logo: {
      path: "/cups/slide1/team_logo.png",
      caption: "",
      mime_type: "image/png",
    },
    season: "2023/2024",
    image: {
      path: "/cups/slide1/team_image.png",
      caption: "",
      mime_type: "image/png",
    },
    image_alt: null,
  })),
};

export const cupsHighlight: ICupHighlight = {
  highlight: {
    media_1: {
      caption:
        "Et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco",
      path: "/cups/slide1/highlight1.png",
      mime_type: "image/jpeg",
    },
    media_2: {
      caption:
        "Et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco",
      path: "/cups/slide1/highlight2.png",
      mime_type: "image/jpeg",
    },
  },
};

export const cupGallery: ICupsGallery = {
  gallery: [
    {
      caption: "",
      path: "/gallery/game1.png",
      mime_type: "image/jpeg",
    },
    {
      caption:
        "Et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco",
      path: "/gallery/game2.png",
      mime_type: "image/jpeg",
    },
    {
      caption: "",
      path: "/gallery/game4.png",
      mime_type: "image/jpeg",
    },
    {
      caption: "Punakaiki Coast",
      path: "https://images.unsplash.com/photo-1707007694363-b8afb46ed639?q=80&w=2971&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      mime_type: "image/jpeg",
    },
    {
      caption: "Golden Hour",
      path: "https://images.unsplash.com/photo-1522747776116-64ee03be1dad?q=80&w=2970&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      mime_type: "image/jpeg",
    },
  ],
};

export const cups: ICup[] = [
  {
    ...cupsInfo,
    ...cupWinners,
    ...cupGallery,
    ...cupsHighlight,
    id: 1,
  },
  {
    ...cupsInfo,
    ...cupWinners,
    ...cupsHighlight,
    ...cupGallery,
    id: 2,
  },
  {
    ...cupsInfo,
    ...cupWinners,
    ...cupGallery,
    ...cupsHighlight,
    id: 3,
  },
  {
    ...cupsInfo,
    ...cupWinners,
    ...cupGallery,
    ...cupsHighlight,
    id: 4,
  },
];

export const cupsCompetitionInformation: ICupCompetitionInfo[] = [
  {
    id: 1,
    name: "SUPERTAÇA CÂNDIDO DE OLIVEIRA",
    logo: {
      path: "/cups/cup-comp-info.png",
      mime_type: "image/png",
      caption: "",
    },
    extra_info: [
      {
        title: "HIGHLIGHT 1",
        value: "1990",
      },
      {
        title: "HIGHLIGHT 2",
        value: "20.000",
      },
      {
        title: "HIGHLIGHT 3",
        value: "435",
      },
    ],
    modality: {
      id: 1,
      name: "Futebol",
      available_genders: ["male", "female"],
      gender: "",
    },
    gender: "Masculino",
    has_details: true,
    description:
      "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod temporem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam Lorem ipsum dolor sit Amet, consectetur adipiscing elit, sed do eiusmod tempoLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam Lorem ipsum dolor sit amet, consectetur adipiscing.</p>",
  },
];

export const categoryCompetitions: ICategoryCompetitions[] = Array.from(
  { length: 17 },
  (_, id) => ({
    id,
    name: "Supertaça Cândido de Oliveira",
    modality: {
      id: 1,
      name: "Futebol",
      available_genders: ["male", "female"],
      gender: "",
    },
    gender: "Masculino",
    logo: {
      path: "https://admin.fpf.gemadigital.com/uploads/cups/cups-logo.svg",
      mime_type: "image/svg+xml",
      caption: "",
    },
    has_details: true,
  })
);
